import { createStore } from "vuex";
import { NavigationGuardNext, RouteLocationNormalized } from "vue-router";
import Cookies from "js-cookie";

const store = createStore({
  state: {
    isAuthenticated: !!Cookies.get("aure_token"),
    user: JSON.parse(Cookies.get("user") || "{}"),
    token: Cookies.get("aure_token"),
  },
  getters: {
    isAuthenticated: (state) => state.isAuthenticated,
    user: (state) => state.user,
  },
  mutations: {
    SET_AUTHENTICATED(state, isAuthenticated) {
      state.isAuthenticated = isAuthenticated;
    },
    SET_USER(state, user) {
      state.user = user;
    },
    SET_TOKEN(state, token) {
      state.token = token;
    },
  },
  actions: {
    async login({ commit }, { email, password }) {
      await fetch(`${process.env.BACKEND_API_URL}/user/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Invalid credentials");
          }
          return response.json();
        })
        .then((data) => {
          const expiryDate = new Date(
            new Date().getTime() + 3 * 24 * 60 * 60 * 1000
          ); // 3 days from now
          Cookies.set("aure_token", data.token, { expires: expiryDate });
          Cookies.set("user", JSON.stringify(data.user), {
            expires: expiryDate,
          });
          commit("SET_TOKEN", data.token);
          commit("SET_AUTHENTICATED", true);
          commit("SET_USER", data.user);
        })
        .catch((error) => {
          console.error("Login failed:", error);
          throw error;
        });
    },
    async logout({ commit }) {
      try {
        await fetch(`${process.env.BACKEND_API_URL}/logout`, {
          method: "POST",
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error("Logout failed");
            }
            return response.json();
          })
          .then(() => {
            Cookies.remove("aure_token");
            Cookies.remove("user");
            commit("SET_AUTHENTICATED", false);
            commit("SET_USER", {});
            commit("SET_TOKEN", null);
            window.location.reload();
          })
          .catch((error) => {
            console.error("Logout failed:", error);
            throw error;
          });
      } catch (error) {
        console.error("Logout failed:", error);
        throw error;
      }
    },
  },
  modules: {},
});

export default store;

export const authGuard = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) => {
  const isAuthenticated = store.getters.isAuthenticated;

  if (!isAuthenticated) {
    if (to.name !== "login" && to.name !== "signup") {
      next({ name: "login" });
    } else {
      next();
    }
  } else {
    next();
  }
};
